<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<title>Daisies Are Forever</title><link href="css/default.css" rel="stylesheet" type="text/css"/>
<p class="tx"><br/><br/><br/></p>
<p class="txc2"><i>“Without remembrance, there can be no future.”</i><br/><br/></p>
<p class="txc">D<span class="small">R</span>. T<span class="small">HOMAS</span> K<span class="small">LESTIL</span>, <span class="small">PRESIDENT OF</span> A<span class="small">USTRIA</span>, <span class="small">AT THE</span> 55<span class="small">TH ANNIVERSARY OF THE LIBERATION OF THE</span> M<span class="small">AUTHAUSEN</span> C<span class="small">ONCENTRATION</span> C<span class="small">AMP</span><br/><br/><br/><br/></p>
<p class="txc2"><i>“Oh merciful Lord . . . crown our effort with victory . . . and give us faith in the inevitable power of light over darkness, of justice over evil and brutal force . . . so be it. Amen.”</i><br/><br/></p>
<p class="txc">S<span class="small">ERGEI</span>, <span class="small">ARCHBISHOP OF</span> M<span class="small">OSCOW</span>—27 N<span class="small">OVEMBER</span> 1941<br/><br/><br/><br/></p>
<p class="txc2"><i>“In this world you will have trouble. But take heart! I have overcome the world.”</i><br/><br/></p>
<p class="txc">J<span class="small">OHN</span> 16:33 <span class="small">NIV</span><br/><br/><br/><br/></p>
<p class="txc2"><i>“And he saved them from the hand of him that hated them, and redeemed them from the hand of the enemy.”</i><br/><br/></p>
<p class="txc">P<span class="small">SALM</span> 106:10 </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// forward1.vue?74d859d8